// AUTO-GENERATED — do not edit
export * from './getLanguage.js';
export * from './swapImage.js';
